// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3190":"3a4c14446338b7ef","4155":"d847dd9b5e9f2b7b"}[chunkId] + ".js";
};